import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";
import { IGetCateringSupplier } from "./CateringSupplierRepository";

export class GetCateringSupplierByNodeIdEndpoint implements IGetCateringSupplierNodeIdEndpoint
{
    public async execute(nodeId: number): Promise<IGetCateringSupplier>
    {
        try
        {
            const response = await axios.get<IGetCateringSupplier>(apis.allApiv2 + nodeId + `/catering-supplier`);
            return response.data;
        }
        catch (error: any)
        {
            throw ApiError.fromAxiosResponse(error.response as AxiosResponse);
        }
    }
}

export interface IGetCateringSupplierNodeIdEndpoint
{
    execute(nodeId: number): Promise<IGetCateringSupplier>;
}
